export default {"src":"/_next/static/media/load-balancer.a5e6e0d8.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};